export enum YJZChecks {
  SCGHSJ = 'executable_type' //可执行类型

}

export const YJZCheckOptions = [
  YJZChecks.SCGHSJ,
]


export function getYJZChecksName(value: YJZChecks) {
  switch (value) {
    case 'executable_type':
    return '可执行类型'
    default:
    break
  }
}